import type { IconNode } from '../types';

/**
 * @name crosshair-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAzSDVhMiAyIDAgMCAwLTIgMnYzIiAvPgogIDxwYXRoIGQ9Ik0xMiAzdjUiIC8+CiAgPHBhdGggZD0iTTIxIDhWNWEyIDIgMCAwIDAtMi0yaC0zIiAvPgogIDxwYXRoIGQ9Ik0xNiAxMmg1IiAvPgogIDxwYXRoIGQ9Ik0xNiAyMWgzYTIgMiAwIDAgMCAyLTJ2LTMiIC8+CiAgPHBhdGggZD0iTTEyIDE2djUiIC8+CiAgPHBhdGggZD0iTTMgMTZ2M2EyIDIgMCAwIDAgMiAyaDMiIC8+CiAgPHBhdGggZD0iTTMgMTJoNSIgLz4KICA8cGF0aCBkPSJNMTIgMTJoLjAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/crosshair-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const crosshairSquare: IconNode = [
  ['path', { d: 'M8 3H5a2 2 0 0 0-2 2v3', key: '1dcmit' }],
  ['path', { d: 'M12 3v5', key: 'weuidg' }],
  ['path', { d: 'M21 8V5a2 2 0 0 0-2-2h-3', key: '1e4gt3' }],
  ['path', { d: 'M16 12h5', key: 'rsdlri' }],
  ['path', { d: 'M16 21h3a2 2 0 0 0 2-2v-3', key: '18trek' }],
  ['path', { d: 'M12 16v5', key: 'zza2cw' }],
  ['path', { d: 'M3 16v3a2 2 0 0 0 2 2h3', key: 'wsl5sc' }],
  ['path', { d: 'M3 12h5', key: 'p77gmy' }],
  ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
];

export default crosshairSquare;
